import { styled } from '@mui/material/styles';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { CommonFieldStyles } from 'shared/components/Pickers/NewUI/styles';

export const TimePickerStyled = styled(TimePicker)(CommonFieldStyles);
